/**
 * 创建api对象
 */
const Api = {};

const requireContext = require.context('./', false, /\.api.js$/);
requireContext.keys().forEach((path) => {
  const apiObject = requireContext(path).default;
  if (apiObject) {
    const key = path.match(/\.\/(\w+).api/)[1];
    Api[key] = apiObject;
  }
});

export default Api;



// WEBPACK FOOTER //
// ./src/api/index.js